import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['bullet', 'button', 'container'];
  static requiredTargets = [];

  // TARGETS
  declare containerTarget: HTMLDivElement;
  declare buttonTargets: HTMLButtonElement[];
  declare bulletTargets: HTMLButtonElement[];

  changeSlide(e) {
    const index = e.currentTarget.dataset.index;

    this.containerTarget.style.transform = `translateX(${index * -100}%)`;

    this.buttonTargets.forEach((el, i) => {
      if (i === Number(index)) {
        el.classList.add('lg:bg-[#392720]', 'lg:text-white');
        el.classList.remove('lg:bg-white', 'lg:text-primary');
      } else {
        el.classList.remove('lg:bg-[#392720]', 'lg:text-white');
        el.classList.add('lg:bg-white', 'lg:text-primary');
      }
    });

    this.bulletTargets.forEach((el, i) => {
      if (i === Number(index)) {
        el.classList.add('bg-[#392720]');
        el.classList.remove('bg-white');
      } else {
        el.classList.remove('bg-[#392720]');
        el.classList.add('bg-white');
      }
    });
  }
}
